import React from "react";
import { MyAccountButton } from "@pga/pga-component-library";
import MemberDrop from "./MemberDrop";

export default ({
  isLoggedIn,
  me,
  options,
  meEmailMigrationData,
  onToggleDoNotShowAgain,
}) =>
  isLoggedIn ? (
    <MemberDrop
      {...{ me, options, meEmailMigrationData, onToggleDoNotShowAgain }}
    />
  ) : (
    <MyAccountButton />
  );
